import { render, staticRenderFns } from "./InfoSkills.vue?vue&type=template&id=1a69da62&lang=pug"
import script from "./InfoSkills.vue?vue&type=script&lang=ts"
export * from "./InfoSkills.vue?vue&type=script&lang=ts"
import style0 from "./InfoSkills.vue?vue&type=style&index=0&id=1a69da62&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports